import CustomHead from 'components/commons/CustomHead'
import Template from 'components/LP/LP202407/Thanks'
import useLocalStorage from 'hooks/useLocalStorage'

const Thanks: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refAwsAppRunnerLpContactPage')
  return (
    <>
      {fromCorrectFormPage ? (
        <CustomHead
          keyword={'AWS App Runner Webアプリケーション開発 デプロイ'}
          image={'https://aitria.co.jp/img/ogp_logo.png'}
          url={'https://aitria.co.jp/services/awsapprunner/thanks/'}
          title="送信完了 AWS AppRunner | サービス | Aitria（アイトリア）"
          description="AWS App Runner導入支援で、Webアプリケーション開発とデプロイを簡略化できます。ソースコードを直接プッシュするだけで安全でスケーラブルな本番環境に即時デプロイ可能。開発効率を最大化し、運用負荷を軽減します。"
        />
      ) : (
        <></>
      )}
      <Template />
    </>
  )
}

export default Thanks
